import * as React from "react";
import "./tab.component.css";
import { useEffect, useMemo, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconFilter,
  IconSearch,
  IconDownload,
  IconHistory,
  IconCopy,
  IconTrash,
  Icon12Hours,
  IconCheck,
  IconX,
  IconCalendar,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  List,
  Menu,
  rem,
  ScrollArea,
  Select,
  ThemeIcon,
  Title,
  Tooltip,
  Text,
} from "@mantine/core";

import { SelectListItem } from "../../model/SelectListItem";
import { getDocTypSelect, getUsersSelect } from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import {
  SystemProcessTaskModel,
  SystemTaskProcessingModelQuery,
} from "../../model/SystemProcessTaskModel";
import Repository from "../../_base/helper/HttpHelper";
import { ProcessApprove } from "../../model/ProcessApprove";
import { modals } from "@mantine/modals";
import PopupProcess from "../History/PopupProcess";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { ListSystemTaskProcessingSearchModel } from "../../model/BaseSearchModel";
import { useForm } from "@mantine/form";
import {
  getColorByType,
  pageTable,
  rejectFlow,
  repositorySign,
  signTypes,
  styleTable,
} from "../../_base/_const/_constVar";
import { DateInput } from "@mantine/dates";
import { features } from "process";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import HistoryProfile from "../Func/CreateProfile/HistoryProfile/HistoryProfile";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
const ProcessTaskTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<SystemTaskProcessingModelQuery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [openedMenu, setOpenedMenu] = useState(true);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [dataUsers, setUsers] = useState<SelectListItem[]>([]);
  //const [dataDocType, setDocType] = useState<SelectListItem[]>([]);
  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [dataUpdated, setDataUpdated] = useState(false);

  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);

  const search: ListSystemTaskProcessingSearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });
  //
  const dataStatus = [
    { value: "0", label: "Duyệt" },
    { value: "1", label: "Ký ảnh" },
    { value: "2", label: "Ký số" },
    { value: "3", label: "Ký nhánh" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListSystemTaskProcessingSearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        SignType: form.getValues().SignType,
        keySearch: form.getValues().keySearch,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        FromDate: form.getValues().FromDate,
        ToDate: form.getValues().ToDate,
        EmpId: form.getValues().EmpId,
      };

      const baseUrl = "/api/v1/System/task-processing";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

      const response = await repositorySign.get<
        MessageResponse<SystemTaskProcessingModelQuery[]>
      >(url);
      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);

        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setUsers(data);
  }

  const openModelHistory = (ids: number | null) =>
    modals.openConfirmModal({
      title: <Title order={4}>Lịch sử phê duyệt</Title>,
      size: "100%",
      children: <HistoryProfile ids={ids} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });

  // async function getDocType() {
  //   const data = await getDocTypSelect();
  //   if (data && data.length > 0) setDocType(data);
  // }

  const usesMap = useMemo(() => {
    const map = new Map<number, string>();
    dataUsers.forEach((item) => {
      map.set(Number(item.value), item.text);
    });

    return map;
  }, [dataUsers]);

  useEffect(() => {
    const dataUpdate = data.map((item) => ({
      ...item,
      createName: usesMap.get(Number(item.empId ?? 0)) || "",
    }));
    setData(dataUpdate);
  }, [data, usesMap]);

  useEffect(() => {
    getUser();
    // getDocType();
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  function progessTemplate(props: SystemTaskProcessingModelQuery): any {
    return (
      <>
        <Tooltip label="Xem lịch sử phê duyệt">
          <ActionIcon
            onClick={async (e) => {
              await openModelHistory(props.docId);
            }}
            variant="light"
            aria-label="Settings"
            color="blue"
          >
            <IconHistory size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Copy link công việc">
          <ActionIcon
            onClick={() => {
              NotificationExtension.Success("Chức năng đang phát triển !");
            }}
            variant="light"
            aria-label="Settings"
            color="cyan"
          >
            <IconCopy size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        {/* <Tooltip label="Hủy công việc">
          <ActionIcon
            onClick={() => {
              NotificationExtension.Success("Chức năng đang phát triển !");
            }}
            variant="light"
            aria-label="Settings"
            color="red"
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon> */}

        <Tooltip label="Hủy công việc">
          <ActionIcon
            onClick={async () => {
              await rejectFlow(0, props.setUpStepId, fetchData);
            }}
            variant="light"
            aria-label="Settings"
            color="red"
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  function toolTipTask(props: SystemTaskProcessingModelQuery) {
    return (
      <>
        <Box>
          <strong>Mã công việc: </strong>
          {props.docCode ?? ""}
          <br></br>
          <strong>Mã hồ sơ: </strong>
          {props.docName ?? ""}
          <br></br>
          <strong>Loại hợp đồng: </strong>
          {props.docTypeName}
          <br></br>
          <strong>Người khởi tạo: </strong>
          {props.createName}
        </Box>
      </>
    );
  }

  function getTextColorSignType(type: number) {
    switch (type) {
      case 1:
        return {
          text: "Duyệt",
          color: "teal",
        };
      case 2:
        return {
          text: "Ký ảnh và duyệt",
          color: "blue",
        };
      case 3:
        return {
          text: "Ký số và duyệt",
          color: "indigo",
        };
      default:
        return {
          text: "Chưa xử lý",
          color: "gray",
        };
    }
  }

  const columns = React.useMemo<
    MRT_ColumnDef<SystemTaskProcessingModelQuery>[]
  >(
    () => [
      {
        accessorKey: "docId",
        header: "docId",
      },
      {
        accessorKey: "setUpStepId",
        header: "setUpStepId",
      },
      {
        accessorKey: "docCode",
        header: "Mã hồ sơ",
      },
      {
        accessorKey: "signType",
        header: "Loại ký",
        Cell: ({ renderedCellValue }: any) => {
          const type = signTypes.find((x) => x.value === renderedCellValue);
          const color = type ? getColorByType(type.value) : "gray";

          return <Badge color={color}>{type?.label || "Unknown"}</Badge>;
        },
      },
      {
        accessorKey: "taskName",
        header: "Tên công việc",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Tooltip
              transitionProps={{ transition: "pop-bottom-left", duration: 300 }}
              label={toolTipTask(row.original)}
              color="blue"
            >
              <Title order={6}>{renderedCellValue}</Title>
            </Tooltip>
          </>
        ),
      },
      {
        accessorKey: "docName",
        header: "Tên quy trình",
      },

      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "expirdDate",
        header: "Ngày hết hạn",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: () => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row?.setUpStepId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: [
        //   "STT",
        //   "mrt-row-select",
        //   "mrt-row-expand",
        //   "orderNumber",
        //   "orderStatus",
        // ],
        right: ["action"],
      },
      columnVisibility: { setUpStepId: false, docId: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: () => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // displayColumnDefOptions: {
    //   "mrt-row-select": {
    //     size: 1,
    //   },
    //   "mrt-row-expand": {
    //     size: 1,
    //   },
    // },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>

        <form>
          <Grid>
            <Grid.Col span={_span}>
              {" "}
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />{" "}
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Loại ký"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataStatus.map((item) => {
                  return {
                    label: item.label ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`SignType`)}
                {...form.getInputProps("SignType")}
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              <Select
                label="Người thao tác"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataUsers.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  await getUser();
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`EmpId`)}
                {...form.getInputProps("EmpId")}
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              <DateInput
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                placeholder="Chọn..."
                label="Từ ngày"
                key={form.key(`FromDate`)}
                {...form.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                placeholder="Chọn..."
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                label="Đến ngày"
                key={form.key(`FromDate`)}
                {...form.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ProcessTaskTable;
